import { useDoNotCountKidsAsStock as usePlanDoNotCountKidsAsStock } from "@/components/features/items/edit/plan/_shared/ui/components/kids-policy/hooks/use-do-not-count-kids-as-stock";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const useDoNotCountKidsAsStock = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { doNotCountKidsAsStock } = viewModel;

	return usePlanDoNotCountKidsAsStock({ doNotCountKidsAsStock, onSetViewModel });
};
